import { hmapPathParamConfig, hmapPathParamRegex } from "@ngmodules/hmap/hmap.routes";
export const TwoFactorAuthRoutes = [
    {
        "url": `/settings/${hmapPathParamRegex}?activeTab&subTab`,
        "name": "appLayout.harriSH.access-portal.settings.main",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig
        },
        "component": "hmapSettingsPage",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["two-factor-auth"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/two-factor-auth/two-factor-auth.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/settings",
        "name": "appLayout.harriSH.settings",
        "type": "frontend",
        "params": {},
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["two-factor-auth"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/two-factor-auth/two-factor-auth.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/:view?tab&section",
        "name": "appLayout.harriSH.settings.section",
        "type": "frontend",
        "params": {},
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["two-factor-auth"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/two-factor-auth/two-factor-auth.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/edit/profile/:view",
        "name": "appLayout.harriSH.editprofile",
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["two-factor-auth"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/two-factor-auth/two-factor-auth.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/tl/edit/profile/:view",
        "name": "appLayout.schedule.editprofile",
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["two-factor-auth"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/two-factor-auth/two-factor-auth.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/qsrlogin",
        "name": "qsr-login",
        "type": "frontend",
        "params": {},
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["two-factor-auth"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/two-factor-auth/two-factor-auth.downgrade.module");
                }
            },
        ]
    },
];
export const TwoFactorAuthTLRoutes = [
    {
        "url": "/settings",
        "name": "appLayout.schedule.settings",
        "type": "frontend",
        "params": {},
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["two-factor-auth"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Settings - Team Live"
            }
        ],
        "views": {
            "body": {
                templateUrl: "../modules/team_schedule/candidate/settings/views/ts_settings.html",
                controller: "TSCandidateSettingsController"
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/two-factor-auth/two-factor-auth.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/?sidebar&brand",
        "enableUTM": true,
        "enableUsernameReferral": true,
        "name": "homepage",
        "type": "backend-frontend",
        "data": [],
        "returnToOnLogin": true,
        "params": {
            "sidebar": {
                dynamic: true
            },
            "brand": {
                dynamic: true
            }
        },
        "route_styles": {
            styles: ["two-factor-auth"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/two-factor-auth/two-factor-auth.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/setup-mfa",
        "name": "setupMfa",
        "type": "frontend",
        "component": "mfaTlSetupContainer",
        "loginRequired": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["two-factor-auth"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/two-factor-auth/two-factor-auth.downgrade.module");
                }
            }
        ],
    },
];
//# sourceMappingURL=two-factor-auth.routes.js.map